import { render, staticRenderFns } from "./ModalDeleteEventOrganizer.vue?vue&type=template&id=20e97e55&scoped=true"
import script from "./ModalDeleteEventOrganizer.vue?vue&type=script&lang=js"
export * from "./ModalDeleteEventOrganizer.vue?vue&type=script&lang=js"
import style0 from "./ModalDeleteEventOrganizer.vue?vue&type=style&index=0&id=20e97e55&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e97e55",
  null
  
)

export default component.exports